export default "__VITE_ASSET__z6IIITi1__"